import { HttpMethods } from '@codametrix/ui-common';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../core/net';
export const updateConfigurationValue = createAsyncThunk('UPDATE_CONFIGURATION_VALUE', async (payload)=>{
    const { configurationId, tenantId, configValue } = payload;
    return await api({
        endpoint: `/configuration/detail/updateValue/${configurationId}/${tenantId}/v2`,
        init: {
            method: HttpMethods.PUT,
            body: JSON.stringify(configValue)
        }
    }, true, true);
});
export const listConfigurations = createAsyncThunk('LIST_CONFIGURATIONS', async (payload)=>{
    const { tenantId } = payload;
    return await api({
        endpoint: `/configuration/listAllConfigurationByTenantId/${tenantId}/v2?includeEmptyConfigurations=true`,
        init: {
            method: HttpMethods.GET
        }
    });
});
export const fetchConfigDetail = createAsyncThunk('FETCH_CONFIG_DETAIL', async (payload)=>{
    const { configurationId, tenantId } = payload;
    return await api({
        endpoint: `/configuration/detail/${configurationId}/${tenantId}/v2?includeEmptyConfigurations=true`,
        init: {
            method: HttpMethods.GET
        }
    });
});
export const toggleConfigDrawer = createAction('TOGGLE_CONFIG_DRAWER');
export const toggleConfigDrawerContent = createAction('TOGGLE_CONFIG_DRAWER_CONTENT');
export const fetchConfigurationAudit = createAsyncThunk('FETCH_CONFIGURATION_AUDIT', async ({ tenantId, pageNumber, pageSize, serviceLine, searchKey })=>{
    const params = new URLSearchParams({
        tenantId,
        pageNumber: pageNumber?.toString() || '1',
        pageSize: pageSize?.toString() || '20'
    });
    if (serviceLine) {
        params.append('serviceLine', serviceLine);
    }
    if (searchKey) {
        params.append('searchKey', searchKey);
    }
    return await api({
        endpoint: `/configuration/audit/configurationsValues?${params.toString()}`,
        init: {
            method: HttpMethods.GET
        }
    });
});
